import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";

const theme = createMuiTheme({
  overrides: {
    MuiFormControl: {
      root: {
        width: "100%",
        marginBottom: "12px",
      },
    },
    MuiInput: {
      formControl: {
        marginTop: "0 !important",
      },
    },
    MuiInputLabel: {
      root: {
        textTransform: "uppercase",
        fontFamily: "Lato",
        fontSize: "14px",
        lineHeight: "17px",
        padding: "0",
        color: "rgba(255, 255, 255, 0.5) !important",
      },
      formControl: {
        position: "inherit",
        transform: "none !important",
        marginBottom: "12px",
      },
    },
    MuiSelect: {
      root: {
        borderRadius: "6px",
        backgroundColor: "rgba(2, 72, 157, 0.14) !important",
      },
      select: {
        padding: "12px 16px",
        backgroundColor: "#00152E",
      },
      icon: {
        color: "#fff",
      },
    },
    MuiInputBase: {
      input: {
        fontSize: "16px",
        lineHeight: "19px",
        color: "#fff",
      },
    },
    MuiOutlinedInput: {
      input: {
        padding: "12px 16px",
        fontSize: "16px",
        lineHeight: "19px",
      },
      root: {
        "& $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
        "&:hover $notchedOutline": {
          borderColor: "rgba(0, 0, 0, 0.23)",
        },
      },
    },
  },
});

const SMASelectDropdown = (props: any) => {
  const { label, id, options, ...rest } = props;

  return (
    <ThemeProvider theme={theme}>
      <FormControl>
        {label && (
          <InputLabel variant="standard" htmlFor={id}>
            {label}
          </InputLabel>
        )}
        <Select labelId={id} id={`select-${id}`} {...rest}>
          {options.map((o: any, index: number) => {
            return (
              <MenuItem value={o.value} key={index}>
                {o.text}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </ThemeProvider>
  );
};

export default SMASelectDropdown;
